var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserSingleDisable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.683 23.811c-.642-1.674-2.239-3.423-4.593-4.588zM15.049 17.887c-6.235.377-10.08 4.49-10.08 7.51 0 1.081.733 1.634 2.79 1.634h16.446z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.332 15.469a5.59 5.59 0 0 0 3.183-5.06c0-3.125-2.568-5.44-5.515-5.44a5.552 5.552 0 0 0-5.007 3.167z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.384 27.723c.37.37.973.37 1.343 0 .358-.382.37-.973 0-1.342L5.62 4.277a.961.961 0 0 0-1.351 0c-.359.37-.359.985 0 1.342z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSingleDisable);
export default __webpack_public_path__ + "static/media/User_Single-Disable.4503e5202cc721652360f743905cc2ef.svg";
export { ForwardRef as ReactComponent };